import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIRE_APIKEY,
  authDomain: process.env.VUE_APP_FIRE_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_FIRE_DATABASEURL,
  projectId: process.env.VUE_APP_FIRE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIRE_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_FIRE_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_FIRE_APPID,
};

const app = firebase.initializeApp(firebaseConfig)

export const auth = app.auth()
export const storage = app.storage()

export const EmailAuthProvider = firebase.auth.EmailAuthProvider
export const GoogleAuthProvider = firebase.auth.GoogleAuthProvider
export const FacebookAuthProvider = firebase.auth.FacebookAuthProvider


export function getSocialProviderFromId(providerId: string) {
  switch(providerId) {
    case 'facebook':
    case FacebookAuthProvider.PROVIDER_ID: 
    case FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD: 
      return FacebookAuthProvider

    case 'google':
    case GoogleAuthProvider.PROVIDER_ID:
    case GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD:
      return GoogleAuthProvider

    default:
      throw "unkown-social-provider";
  }
}